<template>
  <div class="page-container">
    <el-card>
      <div slot="header">
        <span>聊天管理</span>
      </div>
      <el-table :data="list" v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="群聊名称"></el-table-column>
        <el-table-column prop="memberCount" label="成员数" width="100"></el-table-column>
        <el-table-column prop="lastMessage" label="最后消息"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { vpost } from "@/util/post";

export default {
  name: "ChatManage",
  data() {
    return { list: [], loading: false };
  },
  mounted() { this.fetchData(); },
  methods: {
    fetchData() {
      this.loading = true;
      vpost("/admin/chat/list").then(res => {
        if (res.code === 200) this.list = res.data || [];
      }).finally(() => this.loading = false);
    },
    viewDetail(row) {
      this.$message.info("查看详情功能待实现");
    }
  }
};
</script>
